import request from "./http";

class OutboundRequestLogRepository
{
    async getOneById(id) {
        const path = "outbound-request-log/details";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async gridview(query) {
        const path = "outbound-request-log/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("gridview", error);
        }
    }


}

export default OutboundRequestLogRepository;